'use client';
import { SectionLayout } from './section-layout';
import { IcoMoonIcon } from '../../../../../packages/ui/components/icons';
import { YoutubePlaylist } from './youtube-playlist';
import { PrimaryLink } from '../common/link/primary-link';
import { useIsAuthenticated } from '../../providers/stores/auth-store';

export const PlaylistSection = () => {
  const isLoggedIn = useIsAuthenticated();

  if (!isLoggedIn) {
    return null;
  }

  return (
    <SectionLayout
      title="Youtube Playlist"
      className="px-5 2xl:h-full"
      subtitle={
        <PrimaryLink
          href="https://www.youtube.com/playlist?list=PLB7CJiNeHXFh2L9KzjNqW6sH0AofdeKfs"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className="block underline underline-offset-4 md:hidden">
            See more
          </span>
          <div className="hidden items-center gap-1 md:flex">
            See Playlist
            <IcoMoonIcon iconName="arrow-right" className="size-3" />
          </div>
        </PrimaryLink>
      }
    >
      <YoutubePlaylist />
    </SectionLayout>
  );
};
